import SlideTitle from "@/deck/slides/SlideTitle";
import SlideLeadership from "@/deck/slides/SlideLeadership";
import SlideProblem from "@/deck/slides/SlideProblem";
import SlideLendingScaling from "@/deck/slides/SlideLendingScaling";
import SlideBottleneck from "@/deck/slides/SlideBottleneck";
import SlideBetterWay from "@/deck/slides/SlideBetterWay";
import SlideSolution from "@/deck/slides/SlideSolution";
import SlideWhatWeDo from "@/deck/slides/SlideWhatWeDo";
import SlideBuiltModern from "@/deck/slides/SlideBuiltModern";
import SlideBorrowerApp from "@/deck/slides/SlideBorrowerApp";
import SlidePricing from "@/deck/slides/SlidePricing";
import SlideSavingsCalculator from "@/deck/slides/SlideSavingsCalculator";
import SlideCompetitive from "@/deck/slides/SlideCompetitive";
import SlideTraction from "@/deck/slides/SlideTraction";
import SlideTrackRecord from "@/deck/slides/SlideTrackRecord";
import SlideComplianceReadiness from "@/deck/slides/SlideComplianceReadiness";
import SlideCompliSun from "@/deck/slides/SlideCompliSun";
import SlideComplisunTeam from "@/deck/slides/SlideComplisunTeam";
import SlideComplianceCalculator from "@/deck/slides/SlideComplianceCalculator";
import SlideWhoWeWorkWith from "@/deck/slides/SlideWhoWeWorkWith";
import SlideWhereWeFit from "@/deck/slides/SlideWhereWeFit";
import SlideBuiltForScale from "@/deck/slides/SlideBuiltForScale";
import SlideNextSteps from "@/deck/slides/SlideNextSteps";

// Future Marketplace and Voice Agent slides are hidden for this pitch revision —
// kept on disk so we can re-enable in one line when the client is ready.

export const SLIDES = [
  { label: "Cover", component: SlideTitle },
  { label: "The Team", component: SlideLeadership },
  { label: "The Problem", component: SlideProblem },
  { label: "Market Shift", component: SlideLendingScaling },
  { label: "The Bottleneck", component: SlideBottleneck },
  { label: "A Better Way", component: SlideBetterWay },
  { label: "The Solution", component: SlideSolution },
  { label: "What We Do", component: SlideWhatWeDo },
  { label: "Built for Modern Lending", component: SlideBuiltModern },
  { label: "Borrower App & Portal", component: SlideBorrowerApp },
  { label: "Pricing", component: SlidePricing },
  { label: "Savings Calculator", component: SlideSavingsCalculator },
  { label: "Competitive Benchmarks", component: SlideCompetitive },
  { label: "Traction", component: SlideTraction },
  { label: "Operator Track Record", component: SlideTrackRecord },
  { label: "Compliance Readiness", component: SlideComplianceReadiness },
  { label: "CompliSun Partnership", component: SlideCompliSun },
  { label: "CompliSun Team", component: SlideComplisunTeam },
  { label: "Compliance Calculator", component: SlideComplianceCalculator },
  { label: "Who We Work With", component: SlideWhoWeWorkWith },
  { label: "Where We Fit", component: SlideWhereWeFit },
  { label: "Built for Scale", component: SlideBuiltForScale },
  { label: "Next Steps", component: SlideNextSteps },
];
